<template>
  <div class="ios-glass-page">
    <div class="background-blobs">
      <div class="blob blob-1"></div>
      <div class="blob blob-2"></div>
    </div>

    <div class="section-label">目标控制设备</div>
    <div class="glass-card current-device-card" @click="openDevicePopup">
      <div class="device-icon-box" :class="{ 'online': deviceData.code }">
        <van-icon name="desktop-o" size="24" color="#fff" />
        <div class="pulse-ring" v-if="deviceData.code"></div>
      </div>
      <div class="device-content">
        <div class="device-name">{{ deviceData.remark || '请点击选择设备' }}</div>
        <div class="device-status">
          <span v-if="deviceData.code" class="text-green">已选中</span>
          <span v-else class="text-gray">未选择</span>
          <span class="divider">|</span>
          <span>{{ deviceData.ip || '--' }}</span>
        </div>
      </div>
      <div class="arrow-btn">
        <span>切换</span>
        <van-icon name="arrow" />
      </div>
    </div>

    <transition name="van-fade">
      <div v-if="deviceData.code" class="glass-card status-card">
        <div class="status-header">
          <div class="title">当前运行类型</div>
          <div 
            class="status-badge" 
            :class="projectStatus.type === '1' ? 'badge-success' : 'badge-danger'"
          >
            <van-icon :name="projectStatus.type === '1' ? 'unlock' : 'lock'" />
            {{ projectStatus.type === '1' ? '允许切换' : '无需切换' }}
          </div>
        </div>
        
        <div class="current-project-info">
          <div class="project-icon">
            {{ projectStatus.projectName ? projectStatus.projectName.charAt(0) : '?' }}
          </div>
          <div class="project-details">
            <div class="name">{{ projectStatus.projectName || '获取中...' }}</div>
            <div class="code">{{ projectStatus.projectCode || '--' }}</div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="van-slide-up">
      <div v-if="deviceData.code && projectStatus.type === '1'">
        <div class="section-label" style="margin-top: 24px;">选择要切换的类型</div>
        <div class="glass-card grid-card">
          <div class="project-grid">
            <div 
              v-for="(item, index) in switchableProjects" 
              :key="index"
              class="project-item"
              :class="{ 'active': projectStatus.projectCode === item.projectCode }"
              @click="handleSwitchProject(item)"
            >
              <div class="icon-box" :style="{ background: getProjectColor(item.projectCode) }">
                <span class="initial">{{ item.projectName.charAt(0) }}</span>
              </div>
              <div class="name">{{ item.projectName }}</div>
              <div class="running-dot" v-if="projectStatus.projectCode === item.projectCode"></div>
            </div>
          </div>
          
          <van-empty 
            v-if="switchableProjects.length === 0" 
            description="暂无可切换的项目" 
            image="search" 
            :image-size="80" 
          />
        </div>
      </div>
    </transition>

    <transition name="van-slide-up">
      <div v-if="deviceData.code && projectStatus.type === '0'" class="glass-card locked-card">
        <van-icon name="warning-o" size="32" color="#FF3B30" />
        <div class="locked-text">当前设备已锁定，暂不支持切换类型</div>
      </div>
    </transition>

    <van-popup v-model="showDevicePopup" position="bottom" round class="popup-box" :style="{ height: '70%' }">
      <div class="popup-header">
        <div class="title">选择控制设备</div>
        <van-icon name="cross" size="20" color="#999" @click="showDevicePopup = false"/>
      </div>
      <van-search v-model="searchText" placeholder="搜索设备 IP 或备注" shape="round" />
      <div class="popup-content">
        <div class="device-grid">
           <div 
              v-for="item in filteredDeviceList" 
              :key="item.code"
              class="device-item"
              :class="{ 'active': deviceData.code === item.code }"
              @click="onSelectDevice(item)"
            >
              <div class="status-dot"></div>
              <div class="name">{{ item.remark || '未知设备' }}</div>
              <div class="ip">{{ item.ip || 'No IP' }}</div>
           </div>
        </div>
      </div>
    </van-popup>

  </div>
</template>

<script>
import { Dialog } from 'vant';
// 假设这里是你统一定义 API 的地方，请根据实际路径替换
import { 
  selectSchoolDeviceList, 
  selectSwitchProjectStatus, 
  selectSwitchProjectList, 
  switchProject 
} from "@/api/teacher/deviceControl.js"; 

export default {
  name: 'DeviceTypeSwitch',
  data() {
    return {
      teacherTitleInfo: {},
      
      // 设备弹窗控制
      showDevicePopup: false,
      searchText: '',
      deviceList: [], 
      deviceData: {}, // 当前选中的设备

      // 项目切换核心数据
      projectStatus: {
        projectCode: '',
        projectName: '',
        type: null // '0' 不能切换, '1' 可以切换
      },
      switchableProjects: [], // 切换列表
    };
  },
  computed: {
  
    filteredDeviceList() {
      let list = this.deviceList;
      if (this.searchText) {
        const key = this.searchText.toLowerCase();
        list = list.filter(item => {
          // 容错处理：如果值为 null 或 undefined，则默认为空字符串
          const remarkStr = item.remark || '';
          const ipStr = item.ip || '';
          return (remarkStr + ipStr).toLowerCase().includes(key);
        });
      }
      return list;
    }
  },
  mounted() {
    this.teacherTitleInfo = JSON.parse(sessionStorage.getItem('teacherTitleInfo') || '{}');
    this.getDeviceList();
  },
  methods: {
    // 根据 projectCode 生成不同的渐变色彩，符合 Apple 美学
    getProjectColor(code) {
      const gradients = [
        'linear-gradient(135deg, #FF9500, #FFCC00)', 
        'linear-gradient(135deg, #34C759, #30D158)', 
        'linear-gradient(135deg, #007AFF, #5856D6)', 
        'linear-gradient(135deg, #FF2D55, #FF375F)', 
        'linear-gradient(135deg, #AF52DE, #BF5AF2)'
      ];
      let hash = 0;
      if(code) {
        for(let i=0; i<code.length; i++) hash += code.charCodeAt(i);
      }
      return gradients[hash % gradients.length];
    },

    // 1. 获取设备列表 (沿用之前的逻辑)
    getDeviceList() {
      // 此处请求参数根据你实际业务调整
      selectSchoolDeviceList({
        userId: this.teacherTitleInfo.teacherId,
        userName: this.teacherTitleInfo.teacherName,
        schoolCode: this.teacherTitleInfo.schoolCode
      }).then(res => {
        if(res.data && res.data.body) {
          this.deviceList = res.data.body;
        }
      });
    },

    openDevicePopup() {
      this.showDevicePopup = true;
    },

    // 2. 选择设备后，触发新接口查询状态
    async onSelectDevice(item) {
      this.deviceData = item;
      this.showDevicePopup = false;
      this.projectStatus = { projectCode: '', projectName: '', type: null };
      this.switchableProjects = [];
      
      this.$toast.loading({ message: '检测设备状态...', forbidClick: true });
      await this.checkProjectStatus();
      this.$toast.clear();
    },

    // 3. 查询设备是否可以切换 & 当前类型
    async checkProjectStatus() {
      try {
        const res = await selectSwitchProjectStatus({
          schoolCode: this.teacherTitleInfo.schoolCode,
          deviceId: this.deviceData.code // 确保传入正确的 deviceId 字段名
        });
        
        if (res.data && res.data.status === '00' && res.data.body) {
          this.projectStatus = res.data.body;
          // 如果 type 为 '1' (允许切换)，再去拉取列表
          if (this.projectStatus.type === '1') {
            this.getSwitchableList();
          }
        } else {
          this.$toast.fail(res.data.msg || '状态获取失败');
        }
      } catch (e) {
        console.error(e);
      }
    },

    // 4. 查询可切换的项目列表
    async getSwitchableList() {
      try {
        const res = await selectSwitchProjectList({
          schoolCode: this.teacherTitleInfo.schoolCode,
          deviceId: this.deviceData.code
        });
        
        if (res.data && res.data.status === '00') {
          this.switchableProjects = res.data.body || [];
        }
      } catch (e) {
        console.error(e);
      }
    },

    // 5. 点击项目图标执行切换
    handleSwitchProject(item) {
      // 已经是当前运行的项目，无需切换
      if (this.projectStatus.projectCode === item.projectCode) {
        return this.$toast('该类型正在运行中');
      }

      Dialog.confirm({
        title: '确认切换',
        message: `您确定要将设备切换为【${item.projectName}】吗？`,
        confirmButtonColor: '#007AFF',
        cancelButtonColor: '#999'
      }).then(() => {
        this.submitSwitch(item);
      }).catch(() => {});
    },

    // 执行切换 API
    async submitSwitch(item) {
      this.$toast.loading({ message: '指令下发中...', forbidClick: true, duration: 0 });
      try {
        const res = await switchProject({
          schoolCode: this.teacherTitleInfo.schoolCode,
          deviceId: this.deviceData.code,
          projectCode: item.projectCode,
          projectName: item.projectName 
        });

        if (res.data && res.data.status === '00') {
          this.$toast.success('切换成功');
          // 切换成功后重新获取当前状态
          this.checkProjectStatus();
        } else {
          this.$toast.fail(res.data.msg || '切换失败');
        }
      } catch (e) {
        this.$toast.clear();
        console.error(e);
      }
    }
  }
};
</script>

<style lang="less" scoped>
/* --- 全局基础 --- */
.ios-glass-page {
  min-height: 100vh;
  background: radial-gradient(circle at top left, #f1f3f9, #dfe4ea);
  padding: 16px;
  padding-bottom: 40px;
  font-family: -apple-system, sans-serif;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.background-blobs {
  position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 0; pointer-events: none;
  .blob { position: absolute; border-radius: 50%; filter: blur(60px); opacity: 0.6; }
  .blob-1 { width: 300px; height: 300px; background: #a0c4ff; top: -50px; left: -50px; animation: float 8s infinite ease-in-out; }
  .blob-2 { width: 250px; height: 250px; background: #b9fbc0; bottom: -50px; right: -50px; animation: float 8s infinite ease-in-out reverse; }
}

@keyframes float { 
  0%, 100% { transform: translateY(0) scale(1); } 
  50% { transform: translateY(20px) scale(1.05); } 
}

.section-label {
  position: relative; z-index: 1; font-size: 14px; font-weight: 600; color: #6e6e73; margin: 0 0 10px 4px;
}

/* --- 公用毛玻璃卡片 --- */
.glass-card {
  position: relative; z-index: 1;
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 20px;
  padding: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.04);
  margin-bottom: 16px;
}

/* --- 当前设备卡片 --- */
.current-device-card {
  display: flex; align-items: center; transition: transform 0.1s; cursor: pointer;
  &:active { transform: scale(0.98); background: rgba(255, 255, 255, 0.4); }
  
  .device-icon-box {
    width: 48px; height: 48px; background: #d1d1d6; border-radius: 14px;
    display: flex; align-items: center; justify-content: center; margin-right: 14px; position: relative;
    &.online { background: linear-gradient(135deg, #34C759, #30D158); box-shadow: 0 4px 12px rgba(52, 199, 89, 0.3); }
    .pulse-ring {
      position: absolute; width: 100%; height: 100%; border-radius: 14px;
      border: 2px solid #34C759; opacity: 0; animation: ripple 2s infinite;
    }
  }

  .device-content {
    flex: 1;
    .device-name { font-size: 17px; font-weight: 600; color: #1c1c1e; margin-bottom: 4px; }
    .device-status {
      font-size: 13px; color: #8e8e93; display: flex; align-items: center;
      .divider { margin: 0 8px; color: #d1d1d6; }
      .text-green { color: #34C759; font-weight: 500; }
      .text-gray { color: #8e8e93; }
    }
  }
  .arrow-btn { font-size: 13px; color: #007AFF; display: flex; align-items: center; font-weight: 500;}
}

/* --- 状态卡片 --- */
.status-card {
  padding: 20px;
  .status-header {
    display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;
    .title { font-size: 15px; font-weight: 600; color: #1c1c1e; }
    .status-badge {
      display: flex; align-items: center; gap: 4px; font-size: 12px; font-weight: 600; padding: 4px 10px; border-radius: 20px;
      &.badge-success { background: rgba(52, 199, 89, 0.15); color: #34C759; }
      &.badge-danger { background: rgba(255, 59, 48, 0.15); color: #FF3B30; }
    }
  }
  .current-project-info {
    display: flex; align-items: center; background: rgba(255, 255, 255, 0.4); padding: 12px; border-radius: 16px;
    .project-icon {
      width: 44px; height: 44px; border-radius: 12px; background: #007AFF; color: #fff; font-size: 20px; font-weight: bold;
      display: flex; align-items: center; justify-content: center; margin-right: 14px;
      box-shadow: 0 4px 10px rgba(0, 122, 255, 0.3);
    }
    .project-details {
      .name { font-size: 18px; font-weight: 700; color: #1c1c1e; margin-bottom: 2px; }
      .code { font-size: 12px; color: #8e8e93; font-family: monospace; }
    }
  }
}

/* --- 锁定状态卡片 --- */
.locked-card {
  display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 30px 16px;
  background: rgba(255, 255, 255, 0.3);
  .locked-text { margin-top: 12px; font-size: 14px; color: #6e6e73; font-weight: 500; }
}

/* --- 切换列表网格 --- */
.grid-card {
  padding: 20px 16px;
}
.project-grid { 
  display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px 12px; 
}
.project-item {
  display: flex; flex-direction: column; align-items: center; position: relative;
  .icon-box {
    width: 60px; height: 60px; border-radius: 16px; display: flex; align-items: center; justify-content: center; 
    color: #fff; font-size: 24px; font-weight: bold; margin-bottom: 8px; 
    box-shadow: 0 6px 14px rgba(0,0,0,0.12); transition: all 0.2s;
  }
  .name { font-size: 13px; color: #333; text-align: center; font-weight: 500; }
  
  .running-dot {
    position: absolute; top: -2px; right: 12px; width: 12px; height: 12px; 
    background: #34C759; border: 2px solid #fff; border-radius: 50%;
  }

  &:active .icon-box { opacity: 0.8; transform: scale(0.92); }
  &.active { opacity: 0.6; pointer-events: none; }
}

/* --- 弹窗样式 --- */
.popup-box { background: #f2f2f7; display: flex; flex-direction: column; }
.popup-header {
  padding: 16px; background: #fff; display: flex; justify-content: space-between; align-items: center;
  border-bottom: 1px solid rgba(0,0,0,0.05);
  .title { font-size: 16px; font-weight: 600; color: #1c1c1e; }
}
.popup-content { flex: 1; overflow-y: auto; padding: 16px; }
.device-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.device-item {
  background: #fff; padding: 14px; border-radius: 14px; border: 2px solid transparent; transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(0,0,0,0.02);
  &.active { border-color: #007AFF; background: #f0f7ff; }
  .status-dot { width: 8px; height: 8px; border-radius: 50%; background: #34C759; margin-bottom: 10px; }
  .name { font-size: 15px; font-weight: 600; margin-bottom: 4px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color: #1c1c1e; }
  .ip { font-size: 12px; color: #8e8e93; font-family: monospace; }
}

@keyframes ripple { 0% { transform: scale(1); opacity: 0.8; } 100% { transform: scale(1.4); opacity: 0; } }
</style>